import * as React from 'react'

import { Button } from '@factorialco/deprecated-design-system'

import Modal from 'modules/core/components/Modal'
import TextField from 'modules/core/components/TextField'
import asyncAction, { isSuccessful } from 'modules/core/lib/asyncAction'
import i18n from 'modules/core/lib/i18n'

import { Action } from 'modules/api_public/components/ApiKeySettings/types'
import { useApiKeys } from 'modules/api_public/store/collections/apiKeys'

interface Props {
  dispatch: React.Dispatch<Action>
}

const CreateModal = ({ dispatch }: Props) => {
  const apiKeys = useApiKeys()
  const [inputName, setInputName] = React.useState<string>('')

  const createKey = async () => {
    const result = await asyncAction(async () => apiKeys.create({ name: inputName }), {
      successMessage: i18n.t('settings.api_keys.new.created'),
    })

    if (isSuccessful(result)) {
      // FIXME: IApiKey has no token property...?
      dispatch({ type: 'showReadModal', keyName: inputName, token: result.value.token })
    } else {
      dispatch({ type: 'closeModals' })
    }
  }

  return (
    <Modal
      title={i18n.t('settings.api_keys.new.title')}
      description={i18n.t('settings.api_keys.new.description')}
      illustration="network-group"
      onClose={() => dispatch({ type: 'closeModals' })}
      onSubmit={createKey}
      footer={
        <>
          <Button type="secondary" onClick={() => dispatch({ type: 'closeModals' })}>
            {i18n.t('settings.api_keys.new.cancel')}
          </Button>
          <Button type="primary" submit>
            {i18n.t('settings.api_keys.new.get_key')}
          </Button>
        </>
      }
    >
      <TextField
        label={i18n.t('settings.api_keys.key_name')}
        placeholder={i18n.t('settings.api_keys.key_name')}
        onChange={setInputName}
      />
    </Modal>
  )
}

export default CreateModal
